import * as d3 from 'd3'
import moment from 'moment'

export default {

  methods: {

    set_LocalValues(){
      // raw data
      this.chartData = JSON.parse(JSON.stringify(this.DataItems))
      let json = JSON.parse(JSON.stringify(this.JQueries))

      this.chartData.forEach(d=> {
        let eDate = moment(`${d.CDATE} 23:59:59`).toDate()
        let sDate = moment(d.CDATE).add(-6, 'days').toDate()
        d.mDate = new Date(d3.mean([sDate, eDate]))
      })

      // Radio
      this.radio = json.radio
      this.radio.x = (this.radio.x == null) ? 20  : this.radio.x;
      this.radio.y = (this.radio.y == null) ? 20 : this.radio.y;
      if(this.Queries.SQL2.length) {
        this.Queries.SQL2.forEach((d,i)=> {
          this.radio.list[i].start = d.START
          this.radio.list[i].end = d.END
        })
      }

      this.title    = json.title
      this.legends  = json.legends
      this.keys     = json.keys
      this.filters  = json.filters
      this.sundries = json.sundries
      this.chartIdx = json.chartIdx ? json.chartIdx : 1

      // set Current
      this.current = this.radio.list[0]
      if(this.getSelectItems) {
        this.getItems = JSON.parse(this.getSelectItems)
        this.current = this.getItems[`current${this.chartIdx}`] ? this.getItems[`current${this.chartIdx}`] : this.radio.list[0]
      }

      // Chart
      this.chart = json.chart

      // Timeline
      this.timeline = json.timeline
      this.timeline.cutoff.date = this.Queries.SQL1[0].CUTOFF
      this.timeline.length = this.chart.width

      // Axes
      this.primary   = json.primary
      this.secondary = json.secondary

      // Summary
      this.summary = json.summary
      let x_ = 5

      this.summary.cols.forEach(d=> {
        if(this.summary.display == 'vertical') x_ = 5
        d.sx = x_
        if(d.align == 'start') d.tx = x_ + this.summary.tPad
        if(d.align == 'middle') d.tx = x_ + (d.width/2)
        if(d.align == 'end') d.tx = x_ + d.width - this.summary.tPad
        d.mx = x_ + (d.width/2)
        d.ex = x_ + d.width
        x_ = x_ + d.width
      })
      
    },
  }
}